<template>
  <div>
    <div v-if="pwStep == 1">
      <div class="tab-wrap" style="padding-bottom: 11px;">重设密码</div>
      <div class="login-wrapper">
        <div class="user-login">
          <div class="form-phone-con">
            <SelectInput
              type="number"
              @onInputChange="phoneChange"
              @onSelectChange="areaChange"
            />
          </div>
          <div class="form-phone-con" style="margin: 0px;">
            <SlotInput :value="loginForm.authCode" :maxlength="6" type="number" placeholder="输入验证码" @onInputChange="authCodeChange">
              <div
                class="code-btn"
                :disabled="!canGetCode || messageButton.disabled"
                :running="running"
                @click="onSendMessage"
              >
                {{ messageButton.text }}
              </div>
            </SlotInput>
          </div>
          <div class="forget-pass"></div>
          <div @click="nextStep"><a-button :disabled="!canSubmit">下一步</a-button></div>
        </div>
      </div>
    </div>
    <div v-if="pwStep == 2">
      <div class="tab-wrap" style="padding-bottom: 11px;">设置新密码</div>
      <div class="login-wrapper">
        <div class="user-login">
          <div class="form-phone-con">
            <SlotInput :value.sync="newPassForm.newPassword" :showPw="showPw1" placeholder="设置密码">
              <span class="password-suffix">
                <i
                  class="iconfont icon-style"
                  :class="elIcon1"
                  autocomplete="auto"
                  @click="showPw1 = !showPw1"
                />
              </span>
            </SlotInput>
          </div>
          <div class="form-phone-con" style="margin: 0px;">
            <SlotInput :value.sync="newPassForm.secondPassword" :showPw="showPw2" placeholder="确认密码">
              <span class="password-suffix">
                <i
                  class="iconfont icon-style"
                  :class="elIcon2"
                  autocomplete="auto"
                  @click="showPw2 = !showPw2"
                />
              </span>
            </SlotInput>
          </div>
          <div class="forget-pass noevent"></div>
          <a-button @click.native="confirmReset">确定</a-button>
        </div>
      </div>
    </div>
    <div v-if="pwStep == 3" style="padding-top: 52px;">
      <div class="tongguo-con">
        <span class="iconfont icon-tongguo-da pic-tongguo" />
        <div class="tongguo-icon">
          <i class="el-icon-circle-check"></i>
        </div>
        <div class="tongguo-txt">密码设置成功</div>
        <a-button @click.native="backLogin">返回登录({{ timeNum }}s)</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import SelectInput from './SelectInput.vue'
import SlotInput from './SlotInput.vue'
import AButton from './Button.vue'
import { checkPhoneArea } from '@/js/utils/index.js'
import TAL_UC from "@udc/tal-passport-jssdk"

export default {
  name: 'ResetPw',
  data() {
    return {
      pwStep: 1,
      loginForm: {
        phone: "",
        selectArea: "86",
        authCode: "",
      },
      newPassForm: {
        newPassword: "",
        secondPassword: "",
      },
      tag: '',
      timeNum: 3,
      messageButton: {
        type: "",
        text: "发送验证码",
        disabled: false,
      },
      running: false,
      showPw1: true,
      showPw2: true,
    }
  },
  components: { SelectInput, SlotInput, AButton },
  watch: {
    '$parent.messageButton': {
      handler(val) {
        this.messageButton = val
      },
      deep: true
    },
    '$parent.running': {
      handler(val) {
        this.running = val
      }
    },
  },
  computed: {
    canGetCode() {
      return checkPhoneArea(this.loginForm.phone, this.loginForm.selectArea)
    },
    canSubmit() {
      return this.canGetCode && /^\d{6}$/.test(this.loginForm.authCode);
    },
    elIcon1() {
      return this.showPw1 ? "icon-biyan" : "icon-yanjing1";
    },
    elIcon2() {
      return this.showPw2 ? "icon-biyan" : "icon-yanjing1";
    },
  },
  methods: {
    nextStep() {
      if(!this.canSubmit) return
      const parmas = {
        data: {
          phone: this.loginForm.phone.toString(),
          vcode: this.loginForm.authCode.toString(),
          type: 4,
        },
        success: (res) => {
          if (res.errcode === 0) {
            this.tag = res.data.tag;
            this.pwStep = 2
          } else {
            this.$message.error("校验失败");
          }
        },
        fail: function (error) {
          this.$message.error(error);
        },
      };
      TAL_UC.checkPhone(parmas);
    },
    phoneChange(value) {
      this.loginForm.phone = value;
    },
    authCodeChange(value) {
      this.loginForm.authCode = value;
    },
    areaChange(value) {
      this.loginForm.selectArea = value;
    },
    passwordChange(value) {
      this.newPassForm.newPassword = value;
    },
    newPasswordChange(value) {
      this.newPassForm.secondPassword = value;
    },
    confirmReset() {
      if (this.newPassForm.newPassword !== this.newPassForm.secondPassword) {
        this.$message.warning("两次密码输入不一致");
        return;
      }
      const data = {
        phone: this.loginForm.phone.toString(),
        phone_code: this.loginForm.selectArea,
        tag: this.tag,
        type: "1",
        password: this.newPassForm.newPassword,
      };
      TAL_UC.setPassword({
        data,
        success: (res) => {
          if (res.errcode === 0) {
            console.log("重新设置成功======", res);
            this.pwStep = 3;
            const timer = setInterval(() => {
              if (this.timeNum <= 0) {
                this.$emit('success')
                clearInterval(timer);
                return;
              }
              this.timeNum--;
            }, 1000);
          } else {
            this.$message.warning(res.errmsg);
          }
        },
        fail: function (error) {
          console.log(error);
        },
      });
    },
    onSendMessage() {
      this.$emit('sendMessage', this.loginForm)
    },
    backLogin() {
      this.$emit('success')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../index.scss';

.tongguo-con {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .pic-tongguo {
    font-size: 70px;
    color: #31cc47;
    display: block;
  }
  .tongguo-icon {
    color: #00b943;
    font-size: 44px;
  }
  .tongguo-txt {
    text-align: center;
    margin-bottom: 60px;
    font-size: 18px;
    font-weight: 400;
    color: #00b943;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/Login/components/ResetPw.vue